module.exports = __webpack_public_path__ + "media/images/applications/email-baf6ea295781822ab2d0ad6144038721.svg";